import { render, staticRenderFns } from "./ListFooterLayout.vue?vue&type=template&id=7883cbb3&"
import script from "./ListFooterLayout.vue?vue&type=script&lang=js&"
export * from "./ListFooterLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports